import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./card.module.css";
export const Card = ({ isHoverable , element ="div" , children  })=>{
    const HtmlElement = element;
    return /*#__PURE__*/ _jsx(HtmlElement, {
        className: cx(styles.card, {
            [styles.hoverable]: isHoverable
        }),
        children: children
    });
};
